export enum UnsplashRecommendedMediaType {
  Images = 'images',
}
